import { routeManager } from '@/utils/route';
import { EntityTypeManager } from './entityTypeManager';

export const entityTypeManager = () => new EntityTypeManager(routeManager);
